import React from "react";
import { Link, navigate } from "gatsby";
import { getCatUrl } from "../lib/helpers";
import { cn } from "../lib/helpers";
import Icon from "./icon";

import * as styles from "../styles/components/category-list.module.css";

const CategoryList = (props) => {

  const {
    items,
    category,
    ptSlug,
    ptTitle
  } = props;

  const allLink = "/" + ptSlug;

  function navigateTo(e) {
    e.preventDefault();
    navigate(e.target.value);
  }

  return (
    <div className={styles.root}>
      <div className="m-hide">
        <h5>Categories</h5>
        <ul>
          <li className={styles.liItem}>
            <Link to={allLink} className={category ? undefined : styles.isCurrent}>All {ptTitle}</Link>
          </li>
          {items.edges.map(({node: item}) => (
            <li key={item.id} className={styles.liItem}>
              <Link to={getCatUrl(ptSlug, item.slug)} className={category === item.slug ? styles.isCurrent : undefined}>
              {item.title}
              <p className={styles.description}>{item.description}</p>
              </Link>
              
            </li>
          ))}
        </ul>
      </div>
      <div className={cn("d-hide", styles.mFilter)}>
        <label htmlFor="filter">Choose A Category</label>
        <Icon symbol="chevron-down-bold" />
        <select id="filter" className="d-hide" onChange={navigateTo} value={category? getCatUrl(ptSlug, category) : ""}>
          <option value={allLink}>
            All {ptTitle}
          </option>
          {items.edges.map(({node: item}) => (
            <option key={item.id} value={getCatUrl(ptSlug, item.slug)}>
              {item.title}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}

export default CategoryList;
